import { Controller } from "@hotwired/stimulus";
import Focus from "lib/focus";

export default class extends Controller {
  static targets = ["trigger", "content", "back"]
  static values = {
    open: {
      type: Boolean,
      default: false
    },
    persist: { type: Boolean, default: false }
  };

  open() {
    this.openValue = true;
  }

  close() {
    this.openValue = false;
  }

  openValueChanged() {
    if (this.openValue) {
      this.#open();
    } else {
      this.#close();
    }
  }

  // Private

  #open() {
    this.triggerTarget.setAttribute("aria-expanded", true);
    Focus.trap(this.contentTarget);
    this.element.addEventListener("keyup", this.#onKeyUp);
  }

  #close() {
    this.triggerTarget.setAttribute("aria-expanded", false);
    Focus.release(this.contentTarget);
    this.element.removeEventListener("keyup", this.#onKeyUp);
  }

  #onKeyUp = (event) => {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    event.stopImmediatePropagation();

    this.openValue = false;
  }
}

window.addEventListener("turbo:before-render", preserveSubmenu);

function preserveSubmenu(event) {
  const newSubmenus = event.detail.newBody.querySelectorAll('[data-controller~="submenu"]')
  const previousSubmenus = Array.from(document.querySelectorAll('[data-controller~="submenu"]'))

  newSubmenus.forEach(ns => {
    if (ns.dataset.submenuPersistValue === "true") {
      const ps = previousSubmenus.find(s => s.id === ns.id)
      if (!ps) return

      ns.dataset.submenuOpenValue = ps.dataset.submenuOpenValue
    }
  })
}
